import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '../hooks/useAuth';
import { GuestRouteProps } from '../types';
import { AUTH_ROUTES } from '../constants';

/**
 * GuestRoute component - Redirects authenticated users away from guest-only routes
 * @param component - Component to render if not authenticated
 * @param redirectTo - Route to redirect to if authenticated (defaults to home)
 */
const GuestRoute: React.FC<GuestRouteProps> = ({ 
  component: Component, 
  redirectTo = AUTH_ROUTES.HOME 
}) => {
  const { isAuth } = useAuth();

  if (isAuth) {
    return <Navigate to={redirectTo} replace />;
  }

  return <Component />;
};

export default GuestRoute;